// Purpose: React entry. Wires router, auth context, renders App.

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App.tsx';
import { AuthProvider } from './auth/AuthContext.tsx';
import './styles.css';

const container = document.getElementById('root');
if (!container) throw new Error('web: #root element not found');

createRoot(container).render(
  <StrictMode>
    {/*
      Commit 5.6m: opt into React Router v6's v7 behaviors. Silences the
      "future flag" console warnings and pre-commits us to the v7 upgrade
      path (state updates inside React.startTransition, splat route
      children resolving relative to their route). No runtime behavior
      change at the routes we ship today — both flags are safe-ons.
    */}
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>
);
